import { render, staticRenderFns } from "./detail-transfer.vue?vue&type=template&id=7b65f49c&"
import script from "./detail-transfer.vue?vue&type=script&lang=js&"
export * from "./detail-transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports